import { observer } from 'mobx-react-lite';
import logo from '../../assets/images/logo_red.png';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Button } from '@/components/common/Button';
import { t } from 'i18next';
import { useStore } from '@/hooks/useStore';
import { ChevronLeft } from 'lucide-react';
import { toastify } from '@/utils/toastify';
import Table from '@/components/table/Table';
import { ColumnDef } from '@tanstack/react-table';
import { flowResult } from 'mobx';

export default observer(function Download() {
    const {
        apiStore: { setLoading },
        filesStore: { checkInvoiceStatus }
    } = useStore();
    const [searchParams, setSearchParams] = useSearchParams();
    const API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
    const location = useLocation();
    const [listData, setListData] = useState<any[]>([]);
    const [platform, setPlatform] = useState('');
    useEffect(() => {
        if (searchParams) {
            const queryParams = new URLSearchParams(location.search);
            const items = queryParams.get('items');
            const platformParams = queryParams.get('platform');
            setPlatform(decodeURIComponent(platformParams || ''));
            const parsedItems = items ? JSON.parse(decodeURIComponent(items)) : [];
            if (parsedItems || parsedItems.length > 0) {
                setListData(parsedItems);
            }
        } else setListData([]);
    }, [searchParams]);

    async function downloadFile(url, fileName = 'OnlinePost-invoice.pdf') {
        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error(`Lỗi khi tải file: ${response.statusText}`);

            const blob = await response.blob();
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);

            return true;
        } catch (error) {
            console.error('Download error:', error);
            return false;
        }
    }

    const handleDownload = async () => {
        const queryParams = new URLSearchParams(location.search);
        const items = queryParams.get('items');
        const parsedItems = items ? JSON.parse(decodeURIComponent(items)) : [];
        const token = decodeURIComponent(queryParams.get('token') || '');

        const ids = parsedItems.map(e => (e.id));
        const checkRes = await flowResult(checkInvoiceStatus({ ids: ids, token: token }));
        if (!checkRes) {
            toastify('error', t('messages.invalid_files'));
            return;
        }

        if (!parsedItems || parsedItems.length === 0) return;
        toastify('info', t('messages.stating_download', { length: parsedItems.length }), { delay: 1500 });
        setLoading(true);
        if (parsedItems.length === 1) {
            const item = parsedItems[0];
            const urlDownload = `https://www.googleapis.com/drive/v3/files/${item.path}?alt=media&key=${API_KEY}`;
            await downloadFile(urlDownload, item.name || `files-${item.path}.pdf`);
            setLoading(false);
            toastify('success', t('messages.download_complete'), { delay: 2000 });
        } else {
            setLoading(false);
            toastify('error', t('messages.invalid_files'), { delay: 2000 });
        }
    };

    const handleBack = () => {
        const queryParams = new URLSearchParams(window.location.search);
        const callbackUrl = queryParams.get('callback');
        if (!callbackUrl) {
            return;
        }
        window.open(callbackUrl, '_blank');
    };

    const columns: ColumnDef<File>[] = [
        {
            header: 'No',
            size: 50,
            enableSorting: false,
            cell: ({ row: { original, index } }) => (
                <div className='flex justify-center items-center content-center'>{index + 1}</div>
            )
        },
        {
            header: t('text.file_name'),
            size: 300,
            enableSorting: false,
            cell: ({ row: { original, index } }) => (
                <div
                    className=' text-[15px] text-black'
                >
                    {original.name}
                </div>
            )
        }

    ];

    return (
        <div className='w-[100vw] h-[100vh] min-w-[300px]'>
            <div className='bg-white flex content-center items-center'>

                <div className='flex justify-center items-center content-center w-full p-4'>
                    <div
                        className='text-main cursor-pointer  absolute flex left-2'
                        onClick={handleBack}
                    >
                        <ChevronLeft />
                        {t('text.back')}
                    </div>
                    <div
                        className='text-white flex justify-center text-4xl font-bold'
                    >
                        <img src={logo} className='w-[60%]' alt={logo} />
                    </div>
                </div>

            </div>
            <div className='mt-4 flex justify-center items-center content-center'>
                <Button
                    className='bg-main  hover:bg-main  cursor-pointer'
                    onClick={handleDownload}
                >
                    {t('text.download')}
                </Button>
            </div>
            {listData.length > 0 &&
                (
                    <div className='space-y-1 px-4 pt-5 '>
                        <p>{t('text.file_to_download')}</p>
                        <Table
                            columns={columns}
                            data={listData}
                            getRowId={row => row.id.toString()}
                            containerClassName={`py-4 overflow-y-scroll scrollbar-hide ${platform === 'ios' ? 'max-h-[65vh]' : 'max-h-[75vh]'}`}
                            showSelectPageSize={false}
                            showPagination={false}
                            showPagingInfo={false}
                            noData={t('messages.no_invoice')}
                            cellClassName='p-2'
                            showTableFooter={false}
                        />
                    </div>
                )}
        </div>
    );
});
